import React, { useState } from "react";
import moment from "moment-timezone";
import './App.scss';
import givingTuesdayLogo from './givingTuesdayLogo.svg';

function App() {

  const now = moment.tz(new Date(), 'America/New_York');
  const givingTuesdayDate = moment.tz("2024-12-03", 'America/New_York').startOf("day");

  const [givingTuesdayCountdown, setGivingTuesdayCountdown] = useState(givingTuesdayDate.diff(now, 'days'));
  const [givingTuesdayStarted, setGivingTuesdayStarted] = useState(now.isAfter(givingTuesdayDate, 'second'));

  return (
    <div className="GivingTuesdayCoutdown">
      <header className="GivingTuesdayCoutdown-header">
        Give <strong>3X</strong> the<br></br>Hope & Healing
      </header>
      {(!givingTuesdayStarted) && (
        <div className="GivingTuesdayCoutdown-subHeader">
          In <span className="GivingTuesdayCoutdown-days">{givingTuesdayCountdown}</span> Days
        </div>
      )}
      <div className="GivingTuesdayCoutdown-img">
        <img id="givingTuesdayLogo" src={givingTuesdayLogo} />
      </div>
    </div>
  );
}

export default App;
